var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-xw-dialog",class:[_vm.orientation == 2 ? 'horizontal' : 'landscape'],attrs:{"id":"background-xw-dialog"},on:{"click":_vm.onBackgroundClick}},[_c('div',{staticClass:"dialog-xw-dialog",attrs:{"id":"dialog-xw-dialog"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }